module.exports = __webpack_public_path__ + "static/media/publicsonar_naturaldisaster_selected.16be32a0.svg";